import {actions as elecContractActions} from '../slices/elecContracts';
import {actions as gasContractActions} from '../slices/gasContracts';

export default {
  electricity: elecContractActions,
  gas: gasContractActions
}